import React from "react";

import { Button, Typography } from "../helper";

const determineColorOnType = (type) => {
  const data = {
    cancel: "#E2136E",
    ok: "#FFF8FB",
  };

  return data[type];
};

const determineBgColorOnType = (type) => {
  const data = {
    ok: "#E2136E",
    cancel: "#FFF8FB",
  };

  return data[type];
};

const useStyle = (type, width) => ({
  typographyStyle: () => ({ fontSize: 14, fontWeight: 600 }),
  baseButtonStyle: (theme) => ({
    borderRadius: theme.spacing(4),
    textTransform: "none",
    height: 38,
    fontSize: 12,
    backgroundColor: determineBgColorOnType(type),
    color: determineColorOnType(type),
    width: width,
    padding: 1,
    "&:hover": {
      backgroundColor: "#fff",
      color: "#3c52b2",
    },
  }),
});

export default function ChallanBaseButton({
  width,
  text,
  type,
  typeOf,
  ...rest
}) {
  const style = useStyle(type, width);

  return (
    <Button
      variant="contained"
      sx={style.baseButtonStyle}
      type={typeOf}
      {...rest}
    >
      <Typography variant="subtitle1" sx={style.typographyStyle}>
        {text}
      </Typography>
    </Button>
  );
}

ChallanBaseButton.defaultProps = {
  width: "100%",
};
